export default __webpack_public_path__ + "static/media/Red0000.9268e24a.png";